import { Injectable, OnInit } from '@angular/core';
import { ScreenBrightness } from '@capacitor-community/screen-brightness';

@Injectable({
  providedIn: 'root',
})
export class BrightnessService implements OnInit {
  brightnessValue: number = 0.8;

  async ngOnInit(): Promise<void> {
    try {
      this.brightnessValue = (await ScreenBrightness.getBrightness()).brightness;
    } catch (error) {
      console.error('Error getting brightness', error);
      this.brightnessValue = 0.8;
    }
  }

  async setBrightness() {
    await ScreenBrightness.setBrightness({ brightness: 1 });
  }

  async resetBrightness() {
    if (this.brightnessValue == 1) this.brightnessValue = 0.8;

    await ScreenBrightness.setBrightness({ brightness: this.brightnessValue });
  }
}
